import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const Consulta = Loadable({
  loader: () => import('../views/PosLojas/Consulta'),
  loading: RouteLoading,
});

const Visualizar = Loadable({
  loader: () => import('../views/PosLojas/Visualizar'),
  loading: RouteLoading,
});

const RoutePosLojas = [
  {
    path: '/pos-loja/consulta',
    exact: true,
    name: 'Pós-Lojas / Consulta',
    component: Consulta,
  },

  {
    path: '/pos-loja/consulta/:id',
    exact: true,
    name: 'Visualizar Loja',
    component: Visualizar,
  },

];

export { RoutePosLojas };
